module.exports = __webpack_public_path__ + "media/images/autopilot/robot-wl-5a0599678eb6ce3fb9dbf5ac691f8186.svg";